import React from 'react'
import filterString from '../common3/filterString'

const InlineHTML = props => {
  const { extra = {} } = props
  const { code = '' } = extra
  
  return (
    <div dangerouslySetInnerHTML={{ __html: filterString(code,props) }} />
  )
}

export default InlineHTML